<template>
  <div>
      <MainMenu />
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'

export default {
    components: {MainMenu},
    methods: {
      initiateCopy() {
        this.$store.dispatch('copyInformation', this.$store.getters.getMachineId)
      },
      openHelpSite() {
        window.open('https://reachus.easytailorapp.com')
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Header.vue